import { render, staticRenderFns } from "./PhotoInfoCard.vue?vue&type=template&id=40708224&scoped=true&"
import script from "./PhotoInfoCard.vue?vue&type=script&lang=js&"
export * from "./PhotoInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PhotoInfoCard.vue?vue&type=style&index=0&id=40708224&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40708224",
  null
  
)

export default component.exports